package com.nonopn.skywatcher.common.app.pages.map.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Person
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingContext
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingUser
import com.nonopn.skywatcher.common.app.api.impl.WarnStateValidationState
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.maps.LatLng
import de.drick.compose.hotpreview.HotPreview

@Composable
fun CounterUsers(
    modifier: Modifier,
    model: MainScreenModel
) {
    val states by model.states.collectAsState()

    CounterDefault(
        modifier,
        model,
        rememberVectorPainter(Icons.Default.Person),
        "${states.usersOnMap.users.size}"
    )
}

@Composable
@HotPreview(widthDp = 150, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 150, heightDp = 50, darkMode = false)
private fun CounterUsersPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        CounterUsers(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(
                false,
                null, ThunderDetectionSurroundingContext(
                    (0..94).map {
                        ThunderDetectionSurroundingUser(
                            id = "$it",
                            latitude = 0.0,
                            longitude = 0.0,
                            alertState = WarnStateValidationState.AllClear
                        )
                    }
                )
            )
        )
    }
}
